import Vue from "vue";
import sessionMixin from "@/components/shared/mixins/sessionMixin";
import { DocumentTypeService, ReservationService } from "smck-service";
import { zDocumentScanner } from "zoox-components";
import { ApiClient } from "zoox-infra";
import { find } from "lodash";
import ReservationDataHeader from "@/components/shared/ReservationDataHeader";
import PersonService from "@/service/person-service";
import CompanyService from "@/service/company-service";
import FNRHService from "@/service/fnrh-service";
import { mapState, mapActions } from "vuex";

export default {
  name: "GuestDocuments",
  props: {
    reservation: {
      type: Object,
      default: {}
    },
    companyName: {
      type: String,
      default: ""
    },
    resubmission: {
      type: Boolean,
      default: false
    },
    orientationTexts: {
      type: Object
    }
  },
  mixins: [sessionMixin],
  components: { zDocumentScanner, ReservationDataHeader },
  data() {
    return {
      apiClient: new ApiClient(),
      reservationService: new ReservationService(),
      personService: new PersonService(),
      docTypeService: new DocumentTypeService(Vue),
      companyService: new CompanyService(Vue),
      FNRHService: new FNRHService(),
      loading: false,
      personDocuments: [],
      scannedDocument: [
        {
          documentTypeId: null,
          front: null,
          back: null
        }
      ],
      disabledNextBtn: true,
      documentsToUpdate: [],
      showMessage: false,
      messageToShow: "",
      successMessage: false,
      selectedDocumentTypeId: null
    };
  },
  watch: {
    reservation: {
      deep: true,
      immediate: true,
      handler: function(value) {
        this.reservation = value;
        if (this.reservation && this.reservation.guests) {
          let currentGuest = this.currentGuest;
          if (!this.currentGuest) {
            currentGuest = find(
              this.reservation.guests,
              g => g.id === this.$route.params.guestId
            );
            this.$setCurrentGuest(currentGuest);
          }
          if (currentGuest != null && currentGuest.documents != null) {
            this.personDocuments = currentGuest.documents;
            this.scannedDocument = [
              Object.assign({}, currentGuest.documents[0])
            ];
            this.selectedDocumentTypeId =
              currentGuest.documents[0].documentTypeId;
            this.disabledNextBtn = false;
          }

          if (
            this.resubmission &&
            this.currentGuest &&
            this.currentGuest.fnrhId
          ) {
            this.FNRHService.getOne(this.currentGuest.fnrhId)
              .then(respDocs => {
                if (respDocs && respDocs.statusCode === 200) {
                  if (!this.validToken(respDocs.documents)) {
                    this.messageToShow = this.$t(
                      "DOCUMENT_SCANNER.INVALID_TOKEN"
                    );
                    this.showMessage = true;
                  } else if (
                    respDocs.documents[0].status !== "replacement_requested"
                  ) {
                    this.messageToShow = this.$t(
                      `DOCUMENT_SCANNER.${respDocs.documents[0].status.toUpperCase()}`
                    );
                    this.successMessage = true;
                    this.showMessage = true;
                  } else {
                    this.personDocuments = respDocs.documents;
                    this.scannedDocument = [
                      Object.assign({}, respDocs.documents[0])
                    ];
                    this.messageToShow = "";
                    this.showMessage = false;
                    this.disabledNextBtn = true;
                  }
                }
              })
              .catch(() => {
                this.showMessage = true;
              });
          }
        }
        this.$nextTick();
      }
    }
  },
  computed: Object.assign(
    {
      hasFooter: function() {
        return !!this.$slots.footer || !!this.$scopedSlots.footer;
      },
      paramsReady() {
        return ["companyParams"].reduce(
          (acc, data) => acc && this[data] !== null,
          true
        );
      },
      documentTypes: function() {
        const company = this.companyService.getCurrentCompany();

        let requiredDocuments = {};
        if (
          company &&
          company.parameters_sc &&
          company.parameters_sc.frnhFormSettings &&
          company.parameters_sc.frnhFormSettings.requiredDocuments
        ) {
          requiredDocuments =
            company.parameters_sc.frnhFormSettings.requiredDocuments;
        }

        return this.docTypeService.getlAllForDocumentScanner(
          requiredDocuments,
          true
        );
      },
      guestId() {
        return this.$route.params.guestId;
      },
      reservationId() {
        return this.$route.params.reservationId;
      }
    },
    mapState({
      currentReservation: "currentReservation",
      isQualifiedGuest: "isQualifiedGuest",
      sessionCurrentGuest: "currentGuest"
    })
  ),
  async mounted() {
    try {
      this.$_gtagPlugin_trackEvent(
        "ENTERED_GUEST_DOCS_SCAN",
        "PORTAL",
        this.guestId
      );
      //if (!this.resubmission && this.currentGuest.fnrhId == null) {

      if (this.currentGuest.personId != null) {
        this.$setCurrentPersonId(this.currentGuest.personId);
      }
      await this.fillDocs(this.currentGuest);
      // }
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  methods: Object.assign(
    {
      validToken(docs) {
        return (
          docs &&
          docs.length &&
          docs[0] &&
          docs[0].token &&
          docs[0].token === this.$route.query.docScanToken
        );
      },
      async fillDocs(guest) {
        let docs = [];
        if (guest && guest.documents && guest.documents.length > 0) {
          docs = guest.documents;
        } else if (guest && guest.personId) {
          try {
            docs = await this.personService.getDocuments(guest.personId);
            this.disabledNextBtn = false;
          } catch (e) {
            console.error(e);
          }
        }

        if (docs != null && docs.length > 0) {
          if (!docs[0].back.includes("open") && !docs[0].front.includes("open"))
            docs.map(d => {
              if (d.documentTypeId === 1 || d.documentTypeId === 3) {
                this.disabledNextBtn = !(d.back != null && d.front != null);
              } else {
                this.disabledNextBtn = d.front == null;
              }
              return d;
            });

          if (
            !this.currentGuest.documents ||
            (this.currentGuest.documents &&
              this.currentGuest.documents.length > 0 &&
              this.currentGuest.documents[0].back === null &&
              this.currentGuest.documents[0].front === null)
          ) {
            this.currentGuest.documents = docs;
          }
          this.scannedDocument = [Object.assign({}, docs[0])];
          this.selectedDocumentTypeId = this.scannedDocument[0].documentTypeId;
          this.personDocuments = docs;
        }
      },
      nextWithoutSendData() {
        Vue.$globalEvent.$emit("tabChange", 2);
      },
      async next() {
        try {
          this.loading = true;
          let respDocuments = await this.saveDocuments(this.scannedDocument);
          if (this.resubmission && this.currentGuest.fnrhId != null) {
            await this.resubmit(respDocuments[0]);
          } else {
            if (
              respDocuments &&
              respDocuments.length > 0 &&
              respDocuments[0].ok
            ) {
              this.currentGuest.documents = respDocuments;

              this.$setCurrentGuest(this.currentGuest);
              this.$emit("update-vuex-guest", this.currentGuest);

              if (
                this.currentGuest.personId != null &&
                this.scannedDocument[0].front != null
              ) {
                const resp = await this.reservationService.updateGuest(
                  this.reservation.id,
                  this.guestId,
                  this.reservation
                );
                if (resp && resp.statusCode === 200) {
                  this.currentReservation = resp;
                  this.$setCurrentReservation(resp);
                }
              }

              this.$_gtagPlugin_trackEvent(
                "GUEST_DOCS_SCAN_FILLED",
                "PORTAL",
                this.guestId
              );

              this.reservationService.updateLocalGuest(this.currentGuest.id, {
                documents: respDocuments
              });

              this.$setCurrentGuest(this.currentGuest);
              this.$setCurrentMobileStep(2);
            }
          }
        } catch (error) {
          this.messageToShow = this.$t("DOCUMENT_SCANNER.UNKNOW_ERROR_SAVING");
          this.showMessage = true;

          this.$_gtagPlugin_trackEvent(
            "GUEST_DOCS_SCAN_FAIL",
            "PORTAL",
            this.guestId
          );
        } finally {
          this.loading = false;
        }
      },
      async resubmit(docToResubmit) {
        const document = Object.assign(
          {},
          this.personDocuments[0],
          docToResubmit,
          {
            status: "document_updated"
          }
        );

        const resp = await this.FNRHService.update(this.currentGuest.fnrhId, {
          documents: [document]
        });
        if (resp && resp.statusCode === 200) {
          this.messageToShow = this.$t(
            "DOCUMENT_SCANNER.DOCUMENT_SENT_SUCCESS"
          );
          this.successMessage = true;
          this.showMessage = true;
        } else {
          this.messageToShow = this.$t("DOCUMENT_SCANNER.UNKNOW_ERROR_SAVING");
          this.showMessage = true;
        }
      },
      async saveDocuments(documents) {
        if (documents[0].front == null) {
          this.currentGuest.documents[0].ok = true;
          return this.currentGuest.documents;
        }

        const documentData = {
          documents
        };

        if (this.currentGuest.personId) {
          return this.personService.saveDocs(
            this.currentGuest.personId,
            documentData
          );
        } else if (
          !this.currentGuest.documents ||
          !this.currentGuest.documents.length
        ) {
          documentData.companyId = this.currentReservation.companyId;
          return this.reservationService.saveDocs(
            this.currentGuest.id,
            documentData
          );
        } else if (
          this.currentGuest.documents &&
          this.currentGuest.documents.length > 0
        ) {
          documentData.companyId = this.currentReservation.companyId;
          return this.reservationService.saveDocs(
            this.currentGuest.id,
            documentData
          );
        } else {
          return Promise.resolve(this.currentGuest.documents);
        }
      },
      onDocumentScanned(scannedDocument) {
        this.scannedDocument = [scannedDocument];
        this.allowPassWithOneDoc(scannedDocument);
      },
      allowPassWithOneDoc(scannedDocument) {
        const { documentTypeId, front, back } = scannedDocument;
        const { childrenNumber } = this.reservation;

        const checkIfHasNotDocument = front == null && back == null;
        const checkIfHasDocument = front == null || back == null;
        const checkDocumentType = documentTypeId === 1 || documentTypeId === 3;

        const hasChild = childrenNumber > 0;
        const checkData = checkDocumentType
          ? checkDocumentType && checkIfHasDocument
          : hasChild && checkDocumentType;

        const result = this.loading || checkIfHasNotDocument || checkData;
        this.disabledNextBtn = result;
      },
      onDocumentTypeChange(documentTypeId) {
        if (
          documentTypeId != null &&
          this.selectedDocumentTypeId != documentTypeId
        ) {
          this.selectedDocumentTypeId = documentTypeId;
          this.scannedDocument = [{ documentTypeId, front: null, back: null }];
          this.disabledNextBtn = true;
        }
      },
      goBack() {
        Vue.$globalEvent.$emit("tabChange", 1);
        this.$setIsBackingStep(true);
      }
    },
    mapActions([
      "$setCurrentGuest",
      "$setCurrentReservation",
      "$setIsBackingStep"
    ])
  )
};
